import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../common/Context/AlertContext";
import { useLoader } from "../../../common/Context/LoaderContext";
import { ManageApis } from "../../../common/APIS/ManageApis";
import notify from "../../../common/Utils/toastService";
import { HARDCODED_PRODUCTKEY } from "../../../common/constant";

function VerifyEmail() {
  const [useraddPopVisible, setuseraddPopVisible] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [timer, setTimer] = useState(0);
  const { state } = useLocation();
  const { emailId } = state || {};

  useEffect(() => {
    let interval;
    if (isDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsDisabled(false);
    }
    return () => clearInterval(interval);
  }, [isDisabled, timer]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      CheckEmailStatus();
    }, 5000);
    if (isVerified) {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isVerified]);

  const CheckEmailStatus = async () => {
    try {
      if (!emailId || emailId == undefined) {
        return;
      }
      let requestBody = {
        emailId: emailId,
        productKey: HARDCODED_PRODUCTKEY,
      };
      const response = await ManageApis(
        "post",
        window.emailConfirmationStatus,
        requestBody
      );
      if (
        response?.status_code == 200 &&
        response?.response_data?.status == "Success" &&
        response?.response_data?.message == "Confirmed"
      ) {
        setIsVerified(true);
        notify.success("Your Email is verified successfully");
        navigate("/login");
        // if (
        //   planDetails?.selectedPlanPrize == 0 ||
        //   planDetails?.selectedPlanPrize == null
        // ) {
        // } else {
        //   navigate("/billing-address");
        // }
      }
    } catch (error) {
      // showAlert(error.message, {
      //   enableWarningIcon: true,
      // });
    } finally {
    }
  };

  const handleResend = async () => {
    setIsDisabled(true);
    setTimer(20);
    try {
      setLoading(true);
      if (!emailId || emailId == undefined) {
        showAlert("EmailId is Missing", {
          enableWarningIcon: true,
        });
        setLoading(false);
        return;
      }
      let requestBody = {
        emailId: emailId,
        productKey: HARDCODED_PRODUCTKEY,
        // productId: planDetails?.productId || "",
      };
      const response = await ManageApis(
        "post",
        window.resendConfirmationEmail,
        requestBody
      );
      if (
        response?.status_code == 200 &&
        response?.response_data?.status == "Success"
      ) {
        notify.success(response?.response_data?.message);
      } else {
        notify.success(response?.response_data?.message);
      }
    } catch (error) {
      showAlert(error.message, {
        enableWarningIcon: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="w-100 d-flex h_100svh ">
        <div
          className="p-3 p-md-0  mx-auto registerMain"
          style={{
            maxWidth: "440px",
            alignContent: "center",
          }}
        >
          <div>
            <div>
              <h3 className="fw_700 mb-2">Great news!</h3>
              <h3 className="font_22 fw_600 mb-3">
                Your verification email has been sent!{" "}
              </h3>

              {/* <h3 className="font_18 fw_600 mb-3">{EmailId || ''}</h3> */}

              <p>
                Just a heads-up! The link expires in 10 minutes, so check your
                inbox and complete the process right away.
              </p>
              <p className="text_gray10">
                And don’t forget to check your spam folder too, just in case! 😊
              </p>
              <button
                onClick={handleResend}
                disabled={isDisabled}
                style={{ height: "35px", fontSize: "13px" }}
                className={`w-100 btn1 btn-primary1 rounded fw_500 px-4 mt-3 ${
                  isDisabled && "disable_div"
                }`}
              >
                Resend Email
              </button>
              {isDisabled && (
                <p className="text-center font_10 pt-2">
                  Retry after {timer} seconds
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VerifyEmail;
